import { Component, effect, inject } from '@angular/core';

import { ToolbarService } from '@common/toolbar/toolbar.service';

@Component({
    selector: 'sas-validation-checklist-control',
    standalone: true,
    imports: [],
    templateUrl: './sas-validation-checklist-control.component.html',
    styleUrl: './sas-validation-checklist-control.component.scss'
})
export class SasValidationChecklistControlComponent {
    private toolbarService = inject(ToolbarService);

    showBtn: boolean = false;
    private isOpen: boolean = false;

    constructor() {
        effect(() => {
            const showValidationChecklistControl = this.toolbarService.validationChecklistControlShow();
            const isValidationCheckListOpen = this.toolbarService.isValidationChecklistOpen();

            if (showValidationChecklistControl !== null) {
                this.showBtn = showValidationChecklistControl;
            }

            this.isOpen = isValidationCheckListOpen !== null ? isValidationCheckListOpen : false
        });
    }

    toggle() {
        this.toolbarService.setIsValidationCheckListOpen(!this.isOpen);
    }
}
